import { defineStore, acceptHMRUpdate } from "pinia";
import api from "../services/api.js";
import {useUserStore} from "./users.js";

export const useCallStore = defineStore("calls", {
    state: () => ({
        _calls: null,
        _call: null,
        _order_history: null,
        _filter_data: null,
        _stats: null,
    }),

    getters: {
        calls: (state) => state._calls,
        call: (state) => state._call,
        order_history: (state) => state._order_history,
        filter_data: (state) => state._filter_data,
        stats: (state) => state._stats,
    },

    actions: {
        async getCalls(params) {
            const response = await api.get('calls', params)
            this._calls = response.data
        },
        resetCalls() {
            this._calls = null
        },
        async getCall(callId) {
            const response = await api.get(`calls/${callId}`)
            this._call = response.data.call
            this._order_history = response.data.order_history
        },
        async createCall(reseller_order_uuid) {
            const response = await  api.post('/calls', {reseller_order_uuid})
            this._call = response.data.call
        },
        async getCallTypes() {
            const res = await api.get('calls/types');

            return res.data;
        },
        async searchCalls(query) {
            const response = await api.post(`calls/search`, {query: query})
            this._calls = response.data
        },
        async assignCall(callId, userId) {
            const response = await api.post(`calls/${callId}/assign`, {assignee_id: userId})
            this._call = response.data
        },
        async completeCall(callId) {
            const response = await api.post(`calls/${callId}/complete`)
            this._call = response.data
        },
        async bulkAssignCalls(callIds, userId) {
            const response = await api.post(`calls/bulk-assign`, {
                call_ids: callIds,
                assignee_id: userId
            })
            return response.data
        },
        async bulkCompleteCalls(callIds) {
            const response = await api.post(`calls/bulk-complete`, {
                call_ids: callIds
            })
            return response.data
        },
        async prepareFilterData() {
            const userStore = useUserStore();
            await userStore.getAllUsers({all: false, role: 'internal-agent'});
            const callTypes = await this.getCallTypes();
            let options = [];
            userStore.users.forEach(u => {
                options.push({label: `${u.first_name} ${u.last_name}`, value: u.id})
            })

            this._filter_data = {
                sorting: [
                    { label: 'Latest first', value: 'desc' },
                    { label: 'Oldest first', value: 'asc' },
                ],
                assignees: options,
                call_types: callTypes,
                assignment: [
                    { label: 'All', value: null },
                    { label: 'Unassigned', value: 'unassigned' },
                    { label: 'Assigned', value: 'assigned' },
                ]
            }
        },
        async addNote(callId, note){
            await api.post(`calls/${callId}/add-note`, {note})
        },
        async reschedule(callID, data){
            const response = await api.post(`calls/${callID}/reschedule`, data)
            this._call = response.data
        },

        async getStats(date) {
            this._stats = null
            const response = await api.get(`calls/stats`, {date})
            this._stats = response.data
        }
    }
})
